import type { AnalyticsChartPeriod } from 'entities/Analytics'

export const formatDateForDisplay = (dateString: string, period: AnalyticsChartPeriod): string => {
  try {
    const date = new Date(dateString)

    switch (period) {
      case 'month':
        return date.toLocaleDateString('en-US', {
          month: 'long',
          year: 'numeric',
        })
      case 'year':
        return date.getFullYear().toString()
      case 'day':
      case 'week':
      default:
        return date.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
        })
    }
  } catch {
    return dateString
  }
}
